import * as THREE from "three";
import React, { useState, memo } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import Control from '../store/control';
import { Point } from "../shape/Point";

//-----------------------------------------
// Display points that follow the mouse
//-----------------------------------------
// dir: マウスの動く方向（"":制約なし "x":x軸方向のみ）
const MPointMove = memo(({ mesh, origin, color, dir="" }) => {
  const [vpoint, setPoint] = useState(null); //Vector3
  const { camera } = useThree();


  useFrame(({ mouse }) => {
    if(mesh){
      var raycaster = new THREE.Raycaster();
      raycaster.setFromCamera( mouse, camera );

      var intersects = raycaster.intersectObject(mesh, false);

      if (intersects.length == 0) return;
      var pt = intersects[0].point;
      var tmp = null;

      //console.log(dir)

      if(dir == ""){
        tmp = new THREE.Vector3(pt.x, pt.y, pt.z);
      } else {
        //tmp = new THREE.Vector3(pt.x, origin.y, 0);
        tmp = new THREE.Vector3(pt.x, 0, 0);
      }
      setPoint(tmp);
    }
  });

  return (
    <>
      { vpoint ?
        <Point vpoint={vpoint} color={color} size={3} />
        : null }
    </>
  );
});

export const MPointMoveAny = memo(({ color, plane='xy' }) => {
  const [vpoint, setPoint] = useState(null); //Vector3
  const { size, camera } = useThree();

  useFrame(({ mouse }) => {
    var point = null;
    if (plane == 'xy') {
      point = new THREE.Vector3(
        mouse.x * size.width / 2 / camera.zoom,
        mouse.y * size.height / 2 / camera.zoom, 
        0
      );
    } else if (plane == '-xy') {
      point = new THREE.Vector3(
        -mouse.x * size.width / 2 / camera.zoom,
        mouse.y * size.height / 2 / camera.zoom, 
        0
      );
    } else if (plane == 'xz') {
      point = new THREE.Vector3(
        mouse.x * size.width / 2 / camera.zoom,
        0,
        -mouse.y * size.height / 2 / camera.zoom
      );
    } else if (plane == '-xz') {
      point = new THREE.Vector3(
        mouse.x * size.width / 2 / camera.zoom,
        0,
        mouse.y * size.height / 2 / camera.zoom
      );
    } else if (plane == 'yz') {
      point = new THREE.Vector3(
        0,
        mouse.y * size.height / 2 / camera.zoom,
        -mouse.x * size.width / 2 / camera.zoom
      );
    } else if (plane == '-yz') {
      point = new THREE.Vector3(
        0,
        mouse.y * size.height / 2 / camera.zoom,
        mouse.x * size.width / 2 / camera.zoom
      );
    }

    setPoint(point);
  });

  return (
    <>
      { vpoint ?
        <Point vpoint={vpoint} color={color} size={3} />
        : null }
    </>
  );
});

export default MPointMove;
